/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_KnopInputs */

const nl_planning_vakanties_knop = /** @type {(inputs: Planning_Vakanties_KnopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vakanties`)
};

/**

* @param {Planning_Vakanties_KnopInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_knop = /** @type {((inputs?: Planning_Vakanties_KnopInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_KnopInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_knop(inputs)
});
export { planning_vakanties_knop as "planning.vakanties.knop" }